<template>
  <!-- Receipt Number v-if="item"
    :class="{ isCopied: item.is_printed }"-->
  <v-card
    id="Receipt"
    v-if="item"
    :class="{ isCopied: item.is_printed == 1 }"
    flat
    width="290"
    tile
  >
    <v-container>
      <v-row justify="center">
        <v-col cols="12" class="text-center py-0">
          <v-card-title class="justify-center font-weight-bold py-0">
            Order {{ item.order_no }}
          </v-card-title>
          <strong class="d-block x">Receipt {{ item.receipt_no }}</strong>
          <span class="d-block">{{ item.payment_method }}</span>
        </v-col>
        <v-col cols="12" class="pa-0 text-center">
          <span class="d-inline">* * * * * * * * * * * * * * *</span>
        </v-col>
        <v-col cols="12">
          <v-row justify="space-between">
            <v-col cols="12" sm="auto">
              <span class="text-capitalize"
                >User: {{ item ? item.name : "---" }}</span
              >
            </v-col>
            <v-col cols="12" sm="auto">
              <span class="text-capitalize">Date: {{ item.date }}</span>
            </v-col>
          </v-row>
          <v-row justify="space-between">
            <v-col cols="12" sm="auto">
              <span class="text-capitalize">Location: {{ item.cashier }}</span>
            </v-col>
            <v-col cols="12" sm="auto">
              <span class="text-capitalize">Time: {{ item.time }}</span>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="pa-0 text-center">
          <span class="d-inline">- - - - - - - - - - - - - - - -</span>
        </v-col>
        <div
          v-for="(reservation, index) in item.reservations"
          :key="reservation.id"
        >
          <v-col cols="12" class="pa-0 text-center">
            <small>Note that : {{ reservation.notes || "" }}</small>
          </v-col>
          <v-col cols="12" class="pa-0 text-center">
            <span class="d-inline">- - - - - - - - - - - - - - - - -</span>
          </v-col>
          <v-col cols="12" class="text-center">
            <h5
              v-for="participant in reservation.participants.split(',')"
              :key="participant"
              class="justify-center text-capitalize font-weight-bold py-0"
            >
              {{ participant }}
            </h5>
          </v-col>
          <v-col cols="12" class="pa-0 text-center">
            <span class="d-inline">- - - - - - - - - - - - - - - - -</span>
          </v-col>
          <v-col cols="12">
            <v-card-title class="px-0 py-1">
              <h5 class="text-capitalize">
                <span v-if="index > 2">{{ index + 1 }} -</span>
                {{ reservation.subject || "" }}
              </h5>
            </v-card-title>
            <v-row justify="space-between">
              <v-col cols="auto" class="py-1">
                <span class="text-capitalize mr-1"
                  >From:
                  {{
                    reservation.from_date
                      ? reservation.from_date.date
                      : "---" | moment("D/MM/YY")
                  }}</span
                >
              </v-col>
              <v-col cols="auto" class="py-1">
                <span class="text-capitalize mr-1"
                  >To:
                  {{
                    reservation.to_date
                      ? reservation.to_date.date
                      : "" | moment("D/MM/YY")
                  }}</span
                >
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col cols="12" class="py-1">
                <strong class="text-capitalize">Price Break Down</strong>
              </v-col>
            </v-row>
            <v-row justify="space-between" align="center">
              <v-col cols="12" sm="auto" class="py-1">
                <span>Camp Price ---- {{ reservation.camp_price }}</span>
              </v-col>
            </v-row>
            <v-row justify="space-between" align="center">
              <v-col cols="auto" class="py-1">
                <span class="text-capitalize"
                  >Extra Children ---- {{ reservation.children_fees }}</span
                >
              </v-col>
            </v-row>
            <v-row justify="space-between" align="center">
              <v-col cols="12" sm="auto" class="py-1">
                <span class="text-capitalize"
                  >Card Fees ------ {{ reservation.registration_fees }}</span
                >
              </v-col>
            </v-row>
            <v-row
              v-if="checkExtra(reservation.has_bus)"
              justify="space-between"
              align="center"
            >
              <v-col cols="12" sm="auto" class="py-1">
                <span class="text-capitalize"
                  >Bus ----------- {{ reservation.has_bus }}</span
                >
              </v-col>
            </v-row>
            <v-row
              v-if="checkExtra(reservation.has_meal)"
              justify="space-between"
              align="center"
            >
              <v-col cols="12" sm="auto" class="py-1">
                <span class="text-capitalize"
                  >Meal -------- {{ reservation.has_meal }}</span
                >
              </v-col>
            </v-row>
            <v-row
              v-if="checkExtra(reservation.has_photo)"
              justify="space-between"
              align="center"
            >
              <v-col cols="12" sm="auto" class="py-1">
                <span class="text-capitalize"
                  >Photo ---------- {{ reservation.has_photo }}</span
                >
              </v-col>
            </v-row>
            <v-row
              v-if="checkExtra(reservation.has_early_check_in)"
              justify="space-between"
              align="center"
            >
              <v-col cols="12" sm="auto" class="py-1">
                <span class="text-capitalize"
                  >Early Check In --- {{ reservation.has_early_check_in }}</span
                >
              </v-col>
            </v-row>
            <v-row
              v-if="checkExtra(reservation.has_late_check_out)"
              justify="space-between"
              align="center"
            >
              <v-col cols="12" sm="auto" class="py-1">
                <span class="text-capitalize"
                  >Late Check Out ----
                  {{ reservation.has_late_check_out }}</span
                >
              </v-col>
            </v-row>
            <v-row
              v-if="checkExtra(reservation.has_special_needs)"
              justify="space-between"
              align="center"
            >
              <v-col cols="12" sm="auto" class="py-1">
                <span class="text-capitalize"
                  >Special Needs --------
                  {{ reservation.has_special_needs }}</span
                >
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="pa-0 text-center">
            <span class="d-inline">- - - - - - - - - - - - - - - -</span>
          </v-col>
          <v-col cols="12">
            <v-row justify="space-between">
              <v-col cols="12" sm="auto" class="py-1">
                <strong class="text-capitalize"
                  >Discount . . . . . . . -
                  {{ reservation.discount_amount }}</strong
                >
              </v-col>
              <v-col cols="12" sm="auto" class="py-1">
                <strong></strong>
              </v-col>
            </v-row>
            <v-row justify="space-between">
              <v-col cols="12" class="py-0">
                <span class="text-capitalize">{{ reservation.discount }}</span>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row justify="space-between">
              <v-col cols="12" sm="auto" class="py-1">
                <strong class="text-capitalize"
                  >Price after Discount :
                  {{ reservation.price_after_discount }}</strong
                >
              </v-col>
            </v-row>
          </v-col>
          <v-col v-if="index > 1" cols="12" class="pa-0 text-center">
            <span class="d-inline">- - - - - - - - - - - - - - - -</span>
          </v-col>
        </div>
        <v-col cols="12" class="pa-0 text-center">
          <span class="d-inline">* * * * * * * * * * * * * * *</span>
        </v-col>
        <v-col cols="12">
          <v-row justify="space-between">
            <v-col cols="12" sm="auto" class="py-1">
              <strong class="text-capitalize"
                >Net Amount - - ({{ item.receipt_amount }})</strong
              >
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="pa-0 text-center">
          <span class="d-inline">* * * * * * * * * * * * * * * </span>
        </v-col>
        <v-col cols="12" class="text-center flex-column d-flex">
          <span>Thank you for choosing us</span>
          <img
            :src="require('@/assets/imgs/logo.png')"
            fluid
            class="mx-auto my-1"
            width="200px"
          />
          <span>Your feedback keeps us improving</span>
          <span>www.wellspringegypt.com</span>
          <span class="pt-2 pb-0">Hotline</span>
          <v-card-title class="py-0 justify-center font-weight-bold">
            19304
          </v-card-title>
        </v-col>
      </v-row>
    </v-container>

    <!-- Stars Line .trim()
                  .split(" ")
                  .join(":")-->
  </v-card>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      windoWidth: null
    };
  },
  // mounted() {
  //   this.onResize();
  // },
  methods: {
    // onResize() {
    //   this.windoWidth = window.innerWidth;
    // },
    checkExtra(extra) {
      if (parseInt(extra.split(" ")[0]) > 0) {
        return true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#Receipt.isCopied {
  @media print {
    .x {
      background-color: red !important;
    }

    // background: white url("~/public/copied.png") repeat-y center center;
    // background-size: contain;
    // backdrop-filter: opacity(0.1);
    // -webkit-print-color-adjust: exact;
  }
}
#Receipt {
  p {
    page-break-inside: avoid !important;
  }

  .dots-line {
    border-bottom: 1.2px dotted;
  }
}
@media print {
  .col {
    flex-basis: 0;
    -webkit-box-flex: 1;
    flex-grow: 1;
    max-width: 100%;
    padding-bottom: 0;
    padding-top: 0.3em;
  }
  .col-12 {
    -webkit-box-flex: 0;
    flex: 0 0 100%;
    max-width: 100%;
    padding-bottom: 0;
    padding-top: 0.3em;
  }
  .col-sm-auto {
    -webkit-box-flex: 0;
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
}
</style>
